import { Directive, ElementRef, HostListener, inject, Input, Renderer2 } from '@angular/core';

import { BnClipboardService } from '../common-web/services';

@Directive({
  selector: '[bnWebUiCopyToClipboard]',
})
export class CopyToClipboardDirective {
  private el = inject(ElementRef);
  private renderer = inject(Renderer2);

  @Input() textToCopy?: string; // Input to provide the text explicitly.
  @Input() tooltipText = 'Copy to clipboard'; // Optional tooltip input, defaults to "copy to clipboard".
  @Input() fieldName = 'Database URL'; // Optional second parameter input, defaults to "Database URL".
  @Input() preventDefault? = false;
  @Input() stopPropagation? = false;

  private readonly clipboard = inject(BnClipboardService);

  constructor() {
    this.setStyle(); // Add the required CSS styles on initialization.
  }

  private setStyle(): void {
    // Apply inline CSS styles for cursor and text decoration.
    this.renderer.setStyle(this.el.nativeElement, 'cursor', 'copy');
    this.renderer.setStyle(this.el.nativeElement, 'text-decoration', 'underline');

    // Set the tooltip as the element's 'title' attribute.
    this.renderer.setAttribute(this.el.nativeElement, 'title', this.tooltipText);
  }

  @HostListener('click', ['$event']) handleClick(event: Event): void {
    // Get the text to copy: from input if provided, or the element's inner text otherwise.
    const text = this.textToCopy || this.el.nativeElement.innerText.trim();

    if (text) {
      // Call the clipboard service with the text and copy description.
      this.clipboard.copyTextToClipboard(text, this.fieldName);
    } else {
      console.warn('No text available to copy!');
    }

    if (this.preventDefault) {
      event?.preventDefault();
    }

    if (this.stopPropagation) {
      event?.stopPropagation();
    }
  }
}
